import { render, staticRenderFns } from "./ChangeRule.vue?vue&type=template&id=fa85d3e4&scoped=true&"
import script from "./ChangeRule.vue?vue&type=script&lang=js&"
export * from "./ChangeRule.vue?vue&type=script&lang=js&"
import style0 from "./ChangeRule.vue?vue&type=style&index=0&id=fa85d3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa85d3e4",
  null
  
)

export default component.exports